interface EnvVariables {
  businessEmail: string,
  isDev: ComputedRef<boolean>,
  isProd: ComputedRef<boolean>,
  dev: boolean;
  prod: boolean;
  ssr: boolean;
  siteUrl: string;
  prismicAccessToken: string;
  prismicEndpoint: string;
  assChannel: string;
  engChannel: string;
  tlcChannel: string;
  assApiToken: string;
  engApiToken: string;
  tlcApiToken: string;
  trustpilotBusinessId: string;
  trustpilotUrl: string;
  trustpilotTemplateId: string;
}

export const useEnvVariables = (): EnvVariables => {
  // prismicAccessToken/prismicEndpoint passano da runtimeConfig (vedi
  // nuxt.config.ts) e non da import.meta.env.VITE_*: quel meccanismo di Vite
  // viene inlineato in modo affidabile solo nel bundle client, mentre questo
  // composable è usato anche dentro Pinia store durante l'SSR (Nitro/Netlify
  // Function) - senza runtimeConfig il token risultava vuoto lato server e
  // ogni pagina restava senza contenuto Prismic nell'HTML servito, visibile
  // solo dopo l'idratazione lato client.
  const config = useRuntimeConfig()
  const isDev = computed(() => !!import.meta.env.DEV)
  const isProd = computed(() => !!import.meta.env.DEV)

  return {
    businessEmail: import.meta.env.VITE_BUSINESS_EMAIL,
    isDev,
    isProd,
    dev: import.meta.env.DEV,
    prod: import.meta.env.PROD,
    ssr: import.meta.env.SSR,
    siteUrl: import.meta.env.SITE_URL as string || '',
    prismicAccessToken: config.public.prismicAccessToken as string || '',
    prismicEndpoint: config.public.prismicEndpoint as string || '',
    assChannel: import.meta.env.VITE_EUTEL_CHANNEL_ASS as string || '',
    engChannel: import.meta.env.VITE_EUTEL_CHANNEL_ENG as string || '',
    tlcChannel: import.meta.env.VITE_EUTEL_CHANNEL_TLC as string || '',
    assApiToken: import.meta.env.VITE_EUTEL_API_TOKEN_ASS as string || '',
    engApiToken: import.meta.env.VITE_EUTEL_API_TOKEN_ENG as string || '',
    tlcApiToken: import.meta.env.VITE_EUTEL_API_TOKEN_TLC as string || '',
    trustpilotBusinessId: import.meta.env.VITE_TRUSTPILOT_BUSINESSI_UNIT_ID as string || '',
    trustpilotUrl: import.meta.env.VITE_TRUSPILOT_URL as string || '',
    trustpilotTemplateId: import.meta.env.VITE_TRUSTPILOT_TEMPLATE_ID as string || '',
  }
}
